// extracted by css-extract-rspack-plugin
export default {"cls1":"ReaderMessageModal-cls1_3b9","cls2":"ReaderMessageModal-cls2_oiT ReaderMessageModal-cls1_3b9"};